import { Button } from '@cycling-coach/web/components/ui';
import { useHostedConnections } from '../lib/hosted-api';

/**
 * intervals.icu on hosted connects through OAuth (DECISIONS #53), which isn't approved yet — so the
 * button is there but disabled. Hidden once a login is stored (the owner's imported API key).
 */
export function IntervalsConnectAction() {
  const conn = useHostedConnections();
  if (conn.data?.intervals.connected) return null;
  return (
    <span className="flex items-center gap-2">
      <span className="text-xs text-muted">Coming soon</span>
      <Button size="sm" variant="secondary" disabled title="intervals.icu sign-in is coming soon">
        Connect intervals.icu
      </Button>
    </span>
  );
}
